import React from "react";

const Java_min = () => {
  return (
    <div>
      <h1>Java min</h1>
      <p>This page provides explanations, examples, and common use-cases for Java min in Java.</p>
    </div>
  );
};

export default Java_min;
